export default from './post-list-item';



// WEBPACK FOOTER //
// ./app/components/post-list-item/index.js